import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function ShopPage() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "All";
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products/categories").then((r) => setCats(["All", ...r.data])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = category && category !== "All" ? `?category=${encodeURIComponent(category)}` : "";
    api.get(`/products${q}`)
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="container-x py-16 lg:py-20" data-testid="shop-page">
      <div className="max-w-2xl">
        <div className="font-script text-2xl text-[#D97757]">the family</div>
        <h1 className="font-serif text-5xl lg:text-6xl mt-2 leading-tight">Our handmade friends</h1>
        <p className="mt-4 text-[#5C4D43]">
          Browse our current lineup. Each one is unique — and almost every friend can be personalized with a name or birthday on the tag.
        </p>
      </div>

      <div className="mt-10 flex flex-wrap gap-2" data-testid="shop-filters">
        {cats.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase()}`}
            onClick={() => {
              if (c === "All") setParams({});
              else setParams({ category: c });
            }}
            className={`px-5 py-2 rounded-full text-sm transition-all ${
              category === c
                ? "bg-[#2C211B] text-white"
                : "bg-white border border-[#EAE3D9] text-[#2C211B] hover:border-[#D97757]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {loading ? (
          ["a", "b", "c", "d", "e", "f"].map((k) => (
            <div key={`skel-${k}`} className="card-soft p-4 animate-pulse">
              <div className="aspect-[4/5] bg-[#F4EFE6] rounded-2xl" />
              <div className="h-4 bg-[#F4EFE6] mt-4 rounded" />
              <div className="h-3 bg-[#F4EFE6] mt-2 rounded w-2/3" />
            </div>
          ))
        ) : products.length === 0 ? (
          <div className="col-span-full text-center py-20 text-[#5C4D43]">
            No friends here yet — check back soon!
          </div>
        ) : (
          products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)
        )}
      </div>
    </div>
  );
}
